export function wIREFRAUDWARNINGLillardRealtyGroup() {
return [   //2024 Release 2025-06-11 12:11:27
 
{
   page: 0,
   name: "Print Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 528.28,
   left: 133.56,
   width: 226.32,
   height: 12.753
}
,
{
   page: 0,
   name: "Email Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 553.24,
   left: 150.28,
   width: 215.04,
   height: 12.753
}
,
{
   page: 0,
   name: "Print Name_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 628.24,
   left: 134.56,
   width: 226.32,
   height: 12.753
}
,
{
   page: 0,
   name: "Email Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 653.32,
   left: 150.28,
   width: 215.04,
   height: 12.753
}
] }
